import { Button, Stack, Theme, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { BackNavigationClick } from '../../../types/type';
import { ChevronLeftIcon } from '../../shared/Svg-icons/App-Icons';

const BackNavigation = (props: BackNavigationClick) => {
  const theme: Theme = useTheme();
  return (
    <Button
      title="View All Results"
      variant="text"
      sx={{
        '&.MuiButtonBase-root:hover': {
          bgcolor: 'transparent',
        },
        textTransform: 'none',
      }}
      disableRipple={true}
      onClick={props.backNavigationClickHandler}
    >
      <Stack direction="row" spacing={1} justifyContent="flex-start" alignItems="center">
        <ChevronLeftIcon
          viewBox="0 0 50 50"
          sx={{
            overflow: 'visible',
            color: theme.custom.colors.secondaryColor,
            ml: '1rem',
            pt: '10px',
          }}
        />
        <Typography
          tabIndex={0}
          variant="body2"
          sx={{
            ml: '0px',
            color: theme.custom.colors.secondaryColor,
          }}
        >
          {'View All Results'}
        </Typography>
      </Stack>
    </Button>
  );
};

export default BackNavigation;
